"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const react_intl_1 = require("react-intl");
const csvtojson_1 = __importDefault(require("csvtojson"));
const uuid_1 = require("uuid");
const mui_inputs_file_1 = require("@dzambalaorg/mui-inputs-file");
const tables_1 = require("../../../../../../../tables");
const validation_1 = require("../validation");
const FileInput = (props) => {
    const { initialValues } = props;
    const fieldName = "items";
    const filesName = "files";
    const form = (0, react_hook_form_1.useFormContext)();
    const items = (0, react_hook_form_1.useWatch)({ name: fieldName });
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const headers = ["account"];
    const resetForm = () => {
        form.reset(initialValues);
    };
    const parseCsv = async (csv) => {
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.onload = function fileReadCompleted() {
                void (0, csvtojson_1.default)({
                    noheader: true,
                    headers,
                    colParser: {
                        amount: "string",
                    },
                    checkType: true,
                })
                    .fromString(reader.result)
                    .then((data) => {
                    resolve(data.map(items => ({ ...items, id: (0, uuid_1.v4)() })));
                });
            };
            reader.readAsText(csv, "UTF-8");
        });
    };
    const handleChange = async (files) => {
        try {
            const data = await parseCsv(files[0]);
            validation_1.claimsValidationSchema.validateSync({ [fieldName]: data });
            form.setValue(fieldName, data, { shouldDirty: true });
            form.setValue(filesName, files, { shouldDirty: true });
        }
        catch (e) {
            console.error(e);
            form.reset(initialValues);
            form.setError(filesName, { type: "custom", message: "form.validations.badInput" });
        }
    };
    const columns = [
        {
            field: "account",
            headerName: formatMessage({ id: "form.labels.account" }),
            sortable: true,
            flex: 3,
            minWidth: 260,
        },
    ];
    (0, react_1.useEffect)(() => {
        return () => resetForm();
    }, []);
    if (items.length) {
        return (0, jsx_runtime_1.jsx)(tables_1.CsvContentView, { resetForm: resetForm, csvContentName: fieldName, columns: columns });
    }
    return ((0, jsx_runtime_1.jsx)(mui_inputs_file_1.FileInput, { name: filesName, onChange: handleChange, minSize: 0, accept: {
            "text/csv": [".csv"],
        } }));
};
exports.FileInput = FileInput;
//# sourceMappingURL=index.js.map